import React from 'react';

import clsx from 'clsx';

import useI18n, { LocaleTypes } from '@i18n';

import BaseSanitizer from '@components/base/BaseSanitizer';

import RedButton from '@pages/cpa/epnbz/RebButton';
import styles from './Header.module.scss';

const BACKGROUND_CLASS = {
    [LocaleTypes.en]: styles.layout__en,
    [LocaleTypes.ru]: styles.layout__ru,
};

interface IHeaderProps {
    formLink: string;
}

const Header: React.FC<IHeaderProps> = ({ formLink }) => {
    const { t, locale } = useI18n('Cpa');

    return (
        <section className={styles.landingContainer}>
            <div className={clsx(styles.layout, BACKGROUND_CLASS[locale])}>
                <div className={styles.cta}>
                    <BaseSanitizer html={t('Attract traffic with payment for result')} tag="h2" />
                    <BaseSanitizer
                        html={t('We have brought over 30 million customers...')}
                        tag="p"
                    />
                    <RedButton
                        classnames="!w-full sm:!w-auto !bg-[#FF0000]"
                        formLink={formLink}
                        text={t('Join us')}
                    />
                </div>
            </div>
        </section>
    );
};

export default Header;
